import { QueryResult, gql, useQuery } from '@apollo/client';
import { useLoginInput } from 'hooks';
import { EpEmployee } from 'types/graphql-types';

type Skills = {
  employee: Pick<EpEmployee, 'technologies' | 'certificates'>;
};

const GET_SKILLS = gql`
  query GetSkills($login: String!) {
    employee(login: $login) {
      technologies {
        name
      }
      certificates {
        certificate
      }
    }
  }
`;

export const useSkills = (): QueryResult<Skills> =>
  useQuery<Skills>(GET_SKILLS, { variables: useLoginInput() });
